<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="dedi"></a></div>
<p class="dedication"><i>To the bus driver Charles Riley (Daddy), I dedicate this book.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_dedi.vue?5508663c